<template>
  <div>
    <h2 class="building-teaser__title">{{ map.name }}</h2>
    <h4 class="building-teaser__status" :class="{available: objectCount }">{{ objectCount }} {{ objectCount === 1 ? 'woning' : 'woningen' }} beschikbaar</h4>
    <button @click="showPopup()" class="keep-polygon-active btn btn-grey">{{ buttonText }}</button>
  </div>
</template>

<script>
  export default {
    props: ['map'],

      data() {
          return {
             buttonText: 'Bekijk gebouw',
          }
      },

      mounted() {
          if(this.map.is_overlaypopup) {
              this.buttonText = 'Bekijk plattegrond'
          }
      },

      computed: {
      objectCount(){
        let path = this.map.paths[this.map.paths.length - 1] + '/' + this.map.slug
        return this.$filteredObjects.filter((object) => {
          if(object.status !== 'Beschikbaar'){
            return false
          }
          if(object.paths) {
            return object.paths.includes(path);
          }
          return false
        }).length
      }
    },
    methods:{
      showPopup(){
        let newlink = ''
        if(this.map.is_overlaypopup) {
          // Toggle popup with the floor map id
          newlink = this.$route.path + '/popover/' + this.map.slug
        } else {
          newlink = this.$route.path + '/' + this.map.slug
        }
        this.$router.push(newlink)
      },
    }
  }
</script>
